import { render, staticRenderFns } from "./PartnerOrderReview.vue?vue&type=template&id=1d70528a"
import script from "./PartnerOrderReview.vue?vue&type=script&lang=js"
export * from "./PartnerOrderReview.vue?vue&type=script&lang=js"
import style0 from "./PartnerOrderReview.vue?vue&type=style&index=0&id=1d70528a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports